import axios from 'axios';
import URLS from '../../util/urls';

const state = {
  listaContratosReajuste: []
}

const mutations = {
  atualizarListaContratosReajuste(state, payload) {
    state.listaContratosReajuste = payload;
  },

  limparListaContratosReajuste(state) {
    state.listaContratosReajuste = [];
  }
}

const actions = {
  recuperarContratosReajuste(context, payload) {
    return axios.post(URLS.DASHBOARD_RECUPERAR_CONTRATOS_REAJUSTE, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              context.dispatch('recuperarContratosReajuste', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return context.commit('atualizarListaContratosReajuste', response.data.lista);
      }
    }).catch((error) => {
      throw error; 
    });
  }
}

export default {
  state,
  mutations,
  actions
}